import React, { useContext } from 'react';
import TsmThemeContext from 'context/TsmThemeContext';

const withTheme = (WrappedComponent) => React.forwardRef((props, ref) => {
  const theme = useContext(TsmThemeContext);
  return <WrappedComponent {...props} theme={theme} ref={ref} />;
});

export default withTheme;
